export default __webpack_public_path__ + "static/media/menu.c605853a.svg";